// @flow
/** @jsx h */
import { h, Fragment } from 'preact';
import { useErrorModalContext } from '../../storeProviders/errorModalStore';
import { useEffect } from 'preact/hooks';
import { useSalesDispatchContext } from '../../storeProviders/salesAppStore';

const SalesAppErrorSheet = (props) => {
  const errorModalState = useErrorModalContext();
  const { title } = errorModalState || {};
  const salesDispatch = useSalesDispatchContext();

  useEffect(() => {
    if (title) {
      salesDispatch({
        type: 'STORE_STATE',
        payload: {
          bottomSheetConfig: {
            showOverlay: true,
            moduleName: 'ERROR',
          },
        },
      });
    }
  }, [title]);

  return null;
};
export default SalesAppErrorSheet;



// WEBPACK FOOTER //
// ./components/salesApp/SalesAppErrorSheet.js